/* @ngInject */
const errorHandler = (
  userService,
  utils,
  valueHandler
) => {
  const self = {}

  self.message = (res, functionName = 'unnamed', sentData = null) => {
    let message = res.message || ''
    if (res.code === 'token_expired') {
      userService.logout()
    } else if (res[0]) {
      message = 'PHP error => '
      utils.forEach(res, (key, value) => {
        message += key
      })
    } else if (!res) {
      message = 'No server response. Check server path or api source code'
    }

    if (sentData) {
      message += '\nSent data =>\n'
      if (!valueHandler.isObject(sentData)) {
        message += sentData
      } else {
        for (const key in sentData) {
          if (sentData.hasOwnProperty(key)) {
            const value = sentData[key]
            message += key + ' : ' + value + '\n'
          }
        }
      }
    }

    if (res.data) {
      message += 'Receive data =>\n'
      message += res.data
    }

    console.error(functionName + ' : ' + message)
  }

  self.status = (error, functionName = 'unnamed') => {
    if (error.status === 404) {
      console.error('Not found')
    } else if (error.status === -1) {

    }
    console.error(functionName + ' : status = ' + error.status + '; url = ' + error.config.url)
  }

  return self
}
export default errorHandler



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/requests/errorHandler.service.js